//CUSTOM JS GOES HERE


$(document).ready(function() {
    $('#home-banner-slider').slick({
        infinite: true,
        dots: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 4000
    });
});

$('#how-do-i').click(e =>{
    $('.side-panel').css('right', '0px');
});

$('#how-do-i-mobile').click(e =>{
    const svgUse = $mobileNavBtn.find('use');
    $('#mobile-site-nav').fadeOut(100);
    $('.side-panel').css('right', '0px');
    if(svgUse.attr('xlink:href') != '#hamburger-menu'){
        svgUse.attr('xlink:href', '#hamburger-menu');
    }
});


$('#side-panel-close').click(e =>{
    $('.side-panel').css('right', '-400px');
});

//tab linking
function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

let resourceType = getUrlParameter('_resource_type');

let tabParam = getUrlParameter('tab');
if(tabParam){
    //$('.tabs input').attr('checked', 'unchecked');
    $("input[data-tab-slug='" + tabParam + "'").attr('checked', 'checked');
    
}

//search form

const $searchBtn = $('#search-icon');
const searchForm = document.getElementById('header-search');
const searchField = document.getElementById('search-form');
const $mobileNavBtn = $('#hamburger-icon');
const $mobileSiteNav = $('#mobile-site-nav');
const $utilityNav = $('.menu-utility-container');
const $mobileSearchField = $('#mobile-search-form');
const $mobileSearchIcon = $('#mobile-search-icon');



searchField.addEventListener('keydown', (e)=>{      
    
    if(e.keyCode == 13 && searchField.value != ''){
        e.preventDefault();
        window.location.href = '/?s=' + searchField.value;
    }
 });

$searchBtn.on('click', (e)=>{      
    searchForm.classList.toggle("active");
    $utilityNav.toggleClass('utilHide');
    const svgUse = $searchBtn.find('use');
    if(svgUse.attr('xlink:href') == '#icon_search'){
        svgUse.attr('xlink:href', '#icon_menu_close');
        searchField.focus();
    }else{
        svgUse.attr('xlink:href', '#icon_search');
        searchField.blur();
    }
    
});

$mobileSearchIcon.on('click', (e)=>{
    e.preventDefault();
    window.location.href = '/?s=' + $mobileSearchField.val();
});

$mobileSearchField.on('keypress', (e)=>{      
    
    if(e.keyCode == 13 && $mobileSearchField.val() != ''){
        e.preventDefault();
        window.location.href = '/?s=' + $mobileSearchField.val();
    }
 });




$mobileNavBtn.on('click', (e)=>{      
    $mobileSiteNav.fadeToggle(300);
    const svgUse = $mobileNavBtn.find('use');
    if(svgUse.attr('xlink:href') == '#hamburger-menu'){
        svgUse.attr('xlink:href', '#icon_menu_close');
    }else{
        svgUse.attr('xlink:href', '#hamburger-menu');
    }
 });

 $(document).ready(function(){
    $('a').each(function(){
        let theLink = $(this).attr('href');
        
        //add pdf moniker to link
        if(theLink.indexOf('.pdf') >= 0){
            $(this).append('<span class="sr-only">PDF Link</span>');
        }

  

    });

    const docLinks = document.querySelectorAll('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"], a[href$=".xls"], a[href$=".xlsx"], a[href$=".ppt"], a[href$=".pptx"]');

    docLinks.forEach(function(link) {
        link.target = "_blank";
    });

});







